import React from "react";
import { motion } from "framer-motion";
import ScheduleVisualizer from "./ScheduleVisualizer";

const METRICS = [
  { k: "Activities", v: "1,240+", c: "#00E5FF" },
  { k: "Critical Path", v: "84 days", c: "#FFB300" },
  { k: "Float Avg", v: "12.4 d", c: "#F1F5F9" },
  { k: "DCMA Score", v: "13 / 14", c: "#00E5FF" },
];

export const LiveSchedule = () => {
  return (
    <section
      data-testid="live-schedule-section"
      id="live-schedule"
      className="relative py-24 md:py-32 bg-[#04070D] overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Copy */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#00E5FF]" />
              <span className="font-mono-accent text-[11px] text-[#00E5FF]">
                / Live Schedule View
              </span>
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-[#F1F5F9] leading-[1.05] mb-6">
              Your schedule —{" "}
              <span className="text-[#FFB300]">visualized</span>, not buried in
              a Gantt PDF.
            </h2>
            <p className="text-[#94A3B8] text-base lg:text-lg leading-relaxed mb-10 max-w-md">
              Critical activities, near-critical paths, and float consumption —
              tracked in real time and surfaced as decisions, not data dumps.
            </p>

            <div className="grid grid-cols-2 gap-px bg-[#1E2A3B] border border-[#1E2A3B]">
              {METRICS.map((m, i) => (
                <motion.div
                  key={m.k}
                  data-testid={`live-metric-${i}`}
                  initial={{ opacity: 0, y: 14 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="bg-[#0A101D] p-5"
                >
                  <div
                    className="font-heading text-2xl mb-1"
                    style={{ color: m.c }}
                  >
                    {m.v}
                  </div>
                  <div className="font-mono-accent text-[10px] text-[#94A3B8]">
                    {m.k}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* 3D viz */}
          <div className="lg:col-span-7">
            <div className="relative border border-[#1E2A3B] glass-panel aspect-[4/3] lg:aspect-[16/11] overflow-hidden">
              {/* HUD corners */}
              <div className="absolute top-3 left-3 z-10 font-mono-accent text-[10px] text-[#4A6E8C]">
                CPM // LIVE
              </div>
              <div className="absolute top-3 right-3 z-10 flex items-center gap-2 font-mono-accent text-[10px] text-[#00E5FF]">
                <span className="w-1.5 h-1.5 bg-[#00E5FF] animate-pulse" />
                STREAMING
              </div>
              <div className="absolute bottom-3 left-3 z-10 font-mono-accent text-[10px] text-[#4A6E8C]">
                T+ 00:00 — 84d
              </div>
              <div className="absolute bottom-3 right-3 z-10 font-mono-accent text-[10px] text-[#FFB300]">
                CRITICAL × 6
              </div>

              <ScheduleVisualizer />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LiveSchedule;
